import {
  Flex,
  IconButton,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { BsThreeDots } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import VisitasService from "../../../main/services/VisitasService";
import { Link as ReactLink } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import Swal from "sweetalert2";
import {
  criancaFunc,
  Permission,
  visitasFunc,
} from "../../../helpers/Funcionalidades";
import { FiltersCriancas } from "../../components/FiltersCriancas";
import { TableCriancas } from "../../components/TableCriancas";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useAuthProvider } from "../../../Context/AuthProvider";

const ListaVisitas = () => {
  document.title = "MCA - Agenda de Visitas";
  const { roleKeycloack, user } = useAuthProvider();
  const [columns] = useState([
    {
      Header: "Criança/Adolescente",
      accessor: "pessoaFisicaCriancaResponse.nome",
      sortType: (rowA, rowB, id, desc) => {
        let nameA = rowA.original.pessoaFisicaCriancaResponse.nome;
        if (rowA.original.pessoaFisicaCriancaResponse.nomeSocial) {
          nameA += " / " + rowA.original.pessoaFisicaCriancaResponse.nomeSocial;
        }

        let nameB = rowB.original.pessoaFisicaCriancaResponse.nome;
        if (rowB.original.pessoaFisicaCriancaResponse.nomeSocial) {
          nameB += " / " + rowB.original.pessoaFisicaCriancaResponse.nomeSocial;
        }

        return nameA.localeCompare(nameB, "pt-BR");
      },
      Cell: (props) => {
        const id = props?.row?.original?.idCrianca;
        const nome = props.value;

        return (
          <>
            <Link title={nome} as={ReactLink} to={"/crianca/" + id}>
              {nome}
            </Link>
          </>
        );
      },
    },
    {
      Header: "Serviço de Acolhimento",
      accessor: "servicoAcolhimentoResponse",
      Cell: (props) => {
        return (
          <span>{props.value && props.value.nome ? props.value.nome : ""}</span>
        );
      },
      sortType: (rowA, rowB) => {
        const nomeA = rowA.values.servicoAcolhimentoResponse?.nome || "";
        const nomeB = rowB.values.servicoAcolhimentoResponse?.nome || "";
        return nomeA.localeCompare(nomeB);
      },
    },

    {
      Header: "Visitante",
      accessor: "pessoaFisicaVisitanteResponse.nome",
      sortType: (rowA, rowB, id, desc) => {
        let nameA = rowA.original.pessoaFisicaVisitanteResponse.nome;
        if (rowA.original.pessoaFisicaVisitanteResponse.nomeSocial) {
          nameA +=
            " / " + rowA.original.pessoaFisicaVisitanteResponse.nomeSocial;
        }

        let nameB = rowB.original.pessoaFisicaVisitanteResponse.nome;
        if (rowB.original.pessoaFisicaVisitanteResponse.nomeSocial) {
          nameB +=
            " / " + rowB.original.pessoaFisicaVisitanteResponse.nomeSocial;
        }

        return nameA.localeCompare(nameB, "pt-BR");
      },
    },

    {
      Header: "Vínculo",
      accessor: "vinculo",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Data da visita",
      accessor: "dataVisita",
      //disableSortBy: true,
      Cell: (props) => {
        const custom_date = new Date(props?.value).toLocaleDateString("pt-BR");
        return <span>{custom_date ? custom_date : ""}</span>;
      },
    },
    {
      Header: "Opções",
      accessor: "col4",
      disableSortBy: true,
      Cell: (props) => {
        const id = props.row.original.idVisita;
        const { user, roleKeycloack } = props;

        const showMenuItems =
          roleKeycloack?.includes(visitasFunc.visitaEditar) ||
          (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) &&
            user?.orgaoExterno.includes(
              props.row.original.servicoAcolhimentoCrianca?.idPessoaJurica
            ));
        return (
          <Menu>
            <MenuButton
              as={IconButton}
              icon={<BsThreeDots color="#fff" fontSize="20px" />}
              variant={"link"}
              cursor={"pointer"}
              rounded={100}
              p={2}
              backgroundColor="#95BCBF"
            />
            {showMenuItems ? (
              <MenuList>
                {/* <Permission
                roleKeycloack={roleKeycloack}
                func={visitasFunc.visitaVisualizar}
              >
                <Link
                  as={ReactLink}
                  color={"#374BCE"}
                  _hover={{ textDecoration: "none" }}
                  to={"/visitas/" + id}
                >
                  <MenuItem p={2}>
                    <BsEye />
                    <Text ml="5px">Visualizar</Text>
                  </MenuItem>
                </Link>
              </Permission> */}

                <Permission
                  roleKeycloack={roleKeycloack}
                  func={visitasFunc.visitaEditar}
                  id={
                    props.row.original.servicoAcolhimentoResponse
                      ?.idPessoaJurica
                  }
                  user={user}
                >
                  <Link
                    as={ReactLink}
                    color={"#374BCE"}
                    _hover={{ textDecoration: "none" }}
                    to={"/visitas/editar/" + id}
                  >
                    <MenuItem p={2}>
                      <FiEdit />
                      <Text ml="5px">Editar</Text>
                    </MenuItem>
                  </Link>
                </Permission>

                <Permission
                  roleKeycloack={roleKeycloack}
                  func={
                    visitasFunc.visitaTipoConsultar
                      ? visitasFunc.visitaExcluir
                      : visitasFunc.visitaTipoConsultar
                  }
                  id={
                    props.row.original?.servicoAcolhimentoResponse
                      ?.idPessoaJurica
                  }
                  user={user}
                >
                  <MenuItem
                    onClick={() => {
                      checkStatus(id);
                    }}
                    p={2}
                    color={"red.500"}
                  >
                    <AiOutlineClose />
                    <Text ml="5px">Excluir</Text>
                  </MenuItem>
                </Permission>
              </MenuList>
            ) : (
              ""
            )}
          </Menu>
        );
      },
    },
  ]);
  const [data, setData] = useState();
  const [exclusao, setExclusao] = useState(false);
  const [loading, setLoading] = useState(false);

  function checkStatus(id) {
    Swal.fire({
      title: "Ao excluir, as informações sobre essa visita serão excluídas.",
      text: "Deseja Continuar? ",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          VisitasService.deleteVisitas(id).then((res) => {
            Swal.fire({
              title: "Sucesso!",
              text: "Registro Excluído.",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            });
          });
          setExclusao(true);
        } catch (error) {
          console.log(error.response.data);
          Swal.fire({
            title: "Atenção!",
            text: error.response.data.message
              ? error.response.data.message
              : "",
            icon: "error",
            confirmButtonText: "Fechar",
            confirmButtonColor: "#169499",
          });
        }
      }
    });
  }

  return (
    <Flex
      flex={1}
      flexDir="column"
      px={["5px", "32px"]}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <FiltersCriancas
        data={data}
        setData={setData}
        setLoading={setLoading}
        entidade="visitas"
        exclusao={exclusao}
        user={user}
        setExclusao={setExclusao}
        roleKeycloack={roleKeycloack}
      />
      {!loading ? (
        data && (
          <TableCriancas
            data={data.content}
            columns={columns}
            entidade="visitas"
            roleKeycloack={roleKeycloack}
            user={user}
          />
        )
      ) : (
        <>
          <LoadingSpinner />
        </>
      )}
    </Flex>
  );
};

export default ListaVisitas;
